import { render, staticRenderFns } from "./JoinCategory.vue?vue&type=template&id=65a0d5f9"
import script from "./JoinCategory.vue?vue&type=script&lang=js"
export * from "./JoinCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65a0d5f9')) {
      api.createRecord('65a0d5f9', component.options)
    } else {
      api.reload('65a0d5f9', component.options)
    }
    module.hot.accept("./JoinCategory.vue?vue&type=template&id=65a0d5f9", function () {
      api.rerender('65a0d5f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/JoinCategory.vue"
export default component.exports